import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import {
    SectionTitle,
    ProjectSection,
    ProjectsGrid,
    EmptyState,
    AddProjectButton
} from '../../styles/Dashboard.styles';
import StarIcon from '../icons/StarIcon';
import WorkspaceSection from '../WorkspaceSection';

function DashboardProjects({
    projects,
    starredProjects,
    workspaces,
    workspaceOrder,
    projectsByWorkspace,
    unassignedProjects,
    projectOrder,
    starredProjectIds,
    handleMoveProject,
    handleArchiveProject,
    handleDuplicateProject,
    toggleProjectStarStatus,
    renderProjectCard,
    handleDragEnd,
    isModalOpen,
    setIsModalOpen,
    user
}) {
    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            {/* Focused Projects Section */}
            {starredProjects.length > 0 && (
                <ProjectSection>
                    <SectionTitle><StarIcon />Focused Projects</SectionTitle>
                    <Droppable droppableId="starred-projects" direction="horizontal" type="PROJECT">
                        {(provided) => (
                            <ProjectsGrid
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {starredProjects.map((project, index) => (
                                    renderProjectCard(
                                        {
                                            ...project,
                                            uniqueId: `${project.id}-starred`
                                        },
                                        index,
                                        'starred'
                                    )
                                ))}
                                {provided.placeholder}
                            </ProjectsGrid>
                        )}
                    </Droppable>
                </ProjectSection>
            )}

            {/* Workspace Sections */}
            <Droppable droppableId="workspaces" type="WORKSPACE">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        {workspaces
                            .sort((a, b) => {
                                const indexA = workspaceOrder.indexOf(a.id);
                                const indexB = workspaceOrder.indexOf(b.id);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                            })
                            .map((workspace, index) => (
                                <Draggable key={workspace.id} draggableId={workspace.id} index={index}>
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <WorkspaceSection
                                                workspace={workspace}
                                                projects={projectsByWorkspace[workspace.id] || []}
                                                onMoveProject={handleMoveProject}
                                                onToggleStar={(projectId) => toggleProjectStarStatus(
                                                    user.uid,
                                                    projectId,
                                                    starredProjectIds.includes(projectId)
                                                )}
                                                starredProjectIds={starredProjectIds}
                                                onArchive={handleArchiveProject}
                                                onDuplicate={handleDuplicateProject}
                                                renderProjectCard={renderProjectCard}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>

            {/* Unassigned Projects Section */}
            <ProjectSection>
                <SectionTitle>Other Projects</SectionTitle>
                {projects.length === 0 ? (
                    <EmptyState>
                        <p>You haven't created any projects yet.</p>
                        <AddProjectButton onClick={() => setIsModalOpen(true)}>
                            Create your first project
                        </AddProjectButton>
                    </EmptyState>
                ) : (
                    <Droppable droppableId="unassigned-projects" direction="horizontal" type="PROJECT">
                        {(provided) => (
                            <ProjectsGrid
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {unassignedProjects.map((project, index) =>
                                    renderProjectCard(project, index, 'unassigned')
                                )}
                                {provided.placeholder}
                            </ProjectsGrid>
                        )}
                    </Droppable>
                )}
            </ProjectSection>
        </DragDropContext>
    );
}

export default DashboardProjects;